export default "__VITE_ASSET__BO2_wVTK__"